import React, { useContext, useState } from "react";
import Logo from "../components/Logo";
import Image from "../assets/image/landing.png";
import SignupModal from "../components/Modal/SignupModal";
import LoginModal from "../components/Modal/LoginModal";
import { LoginContext } from "../context/loginContext";
import { useHistory } from "react-router-dom";

function Landing(props) {
  const [signup, setsignup] = useState(false);
  const [login, setlogin] = useState(false);
  const [state] = useContext(LoginContext);
  const history = useHistory();
  return (
    <>
      <div className="w-full">
        <div className="grid w-full lg:grid-cols-2 sm:grid-cols-1">
          <div className="lg:pl-16 lg:text-left text-center mb-8 mt-6">
            {/* Logo */}
            <Logo />
            {/* Title */}
            <div className="title-landing lg:text-custom text-6xl mt-24">
              <h1 className="">
                Your <span className="not-italic">library anywhere</span>
              </h1>
            </div>
            {/* Sub Title */}
            <div className="sub-title p-0" style={{ marginTop: "66px" }}>
              Sign-up today and receive unlimited
              <br /> accesss to all of your reading - share
              <br /> your book.
            </div>
            {/* Button  */}
            <div className="flex lg:flex-row flex-col items-center lg:items-start lg:justify-start justify-center lg:space-x-8">
              {state.isLogin ? (
                <>
                  <button
                    className="focus:outline-none w-3/5 lg:w-1/2 text-white px-20 py-3 mt-8 rounded-md"
                    style={{ background: "#EE4622" }}
                    onClick={() => history.push("/index")}
                  >
                    Home
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="focus:outline-none w-3/5 lg:w-1/2 text-white px-20 py-3 mt-8 rounded-md"
                    style={{ background: "#EE4622" }}
                    onClick={() => setsignup(!signup)}
                  >
                    Sign Up
                  </button>
                  <button
                    className="focus:outline-none px-20 w-3/5 lg:w-1/2 py-3 mt-8 rounded-md"
                    style={{ background: "rgba(233, 233, 233, 0.7)" }}
                    onClick={() => setlogin(!login)}
                  >
                    Sign In
                  </button>
                </>
              )}
            </div>
          </div>
          <div
            className="hidden lg:block w-100 min-h-screen"
            style={{
              backgroundImage: "url(" + Image + ")",
              backgroundSize: "cover",
            }}
          ></div>
        </div>
      </div>
      <SignupModal
        toggleLogin={() => setlogin(!login)}
        toggleHandler={() => setsignup(!signup)}
        toggle={signup}
      />
      <LoginModal
        toggleSignup={() => setsignup(!signup)}
        toggleHandler={() => setlogin(!login)}
        toggle={login}
      />
    </>
  );
}

export default Landing;
